import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6cf64294"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "preview_box" }
const _hoisted_3 = { class: "preview_item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "驾驶证正页", -1))
const _hoisted_5 = { class: "preview_item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "驾驶证附页", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"30px"} }, null, -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode("通过")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("不通过")
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding-bottom":"10px","font-weight":"700"} }, "请输入不通过的原因", -1))
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding-bottom":"10px","font-weight":"700"} }, "确定审核通过吗？", -1))
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_image_preview_group = _resolveComponent("a-image-preview-group")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.detail)
      ? (_openBlock(), _createBlock(_component_a_card, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_descriptions, {
              title: "驾驶证认证信息",
              bordered: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_descriptions_item, { label: "姓名" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "手机号" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.userable?.mobile), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "驾驶证号" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.license_number), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "准驾车型" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.type), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "有效期限" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.valid_period_from) + "~" + _toDisplayString(_ctx.detail?.expiration_date === '2099-12-31' ? '长期' : _ctx.detail?.expiration_date), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "签发机关" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.issuing_organizations), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "提交时间" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.update_time), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, {
                  label: "驾驶员从业资格证号",
                  span: 2
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.qualification_certificate), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, {
                  label: "图片",
                  span: 3
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_image_preview_group, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_a_image, {
                              src: _ctx.detail?.image_1,
                              width: 150,
                              height: 150
                            }, null, 8, ["src"]),
                            _hoisted_4
                          ]),
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_a_image, {
                              src: _ctx.detail?.image_2,
                              width: 150,
                              height: 150
                            }, null, 8, ["src"]),
                            _hoisted_6
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_7,
            _createVNode(_component_a_descriptions, {
              title: "审核信息",
              bordered: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_descriptions_item, { label: "审核时间" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.audit ? _ctx.detail?.audit?.create_time : '未审核'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, {
                  label: "审核结果",
                  span: 2
                }, {
                  default: _withCtx(() => [
                    (_ctx.detail?.status === 0)
                      ? (_openBlock(), _createBlock(_component_a_badge, {
                          key: 0,
                          status: "processing",
                          color: "red",
                          text: "审核中"
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.detail?.status === 1)
                      ? (_openBlock(), _createBlock(_component_a_badge, {
                          key: 1,
                          color: "green",
                          text: "通过"
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.detail?.status === 2)
                      ? (_openBlock(), _createBlock(_component_a_badge, {
                          key: 2,
                          color: "orange",
                          text: "未通过"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                (_ctx.detail?.audit?.reason)
                  ? (_openBlock(), _createBlock(_component_a_descriptions_item, {
                      key: 0,
                      label: "备注"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.detail?.audit?.reason), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.detail?.status === 0)
                  ? (_openBlock(), _createBlock(_component_a_descriptions_item, {
                      key: 1,
                      label: "审核操作",
                      span: 3
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setVisible(true, true))),
                          style: {"margin-right":"16px"},
                          type: "primary"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_button, {
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setVisible(true, false)))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.visible) = $event)),
      title: _ctx.pass ? '审核通过' : '审核不通过',
      onOk: _ctx.onAudit,
      confirmLoading: _ctx.loading
    }, {
      default: _withCtx(() => [
        (!_ctx.pass)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_a_textarea, {
                value: _ctx.reason,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.reason) = $event)),
                placeholder: "请输入不通过的原因",
                rows: 4
              }, null, 8, ["value"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
      ]),
      _: 1
    }, 8, ["visible", "title", "onOk", "confirmLoading"])
  ]))
}